/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attribute_Country_Whence_ConsignedInputs */

const en_attribute_country_whence_consigned = /** @type {(inputs: Attribute_Country_Whence_ConsignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consigned from`)
};

/**
* | output |
* | --- |
* | "Consigned from" |
*
* @param {Attribute_Country_Whence_ConsignedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attribute_country_whence_consigned = /** @type {((inputs?: Attribute_Country_Whence_ConsignedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attribute_Country_Whence_ConsignedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attribute_country_whence_consigned(inputs)
});